export const MIN_PROGRESS_VALUE = 0;
export const MAX_PROGRESS_VALUE = 100;

type CalculateProgressValueReqParams = {
  max: number;
  min: number;
  value: number;
};

export const calculateProgressValue = (params: CalculateProgressValueReqParams) => {
  const { value, min, max } = params;

  const calcValue = ((value - min) / (max - min)) * MAX_PROGRESS_VALUE;

  return calcValue > MAX_PROGRESS_VALUE
    ? MAX_PROGRESS_VALUE
    : calcValue < MIN_PROGRESS_VALUE
      ? MIN_PROGRESS_VALUE
      : calcValue;
};
